import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MentorResponse } from '../../models/account/mentor/mentorResponse';
import { MentorService } from '../../services/account/mentor.service';
import { countryResponse } from '../../models/country/countryResponse';
import { UtilityService } from '../../services/utility/utility.service';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../states/user/user-selector';
import { AuthRoles, MentorType } from '../../models/enums/enums';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ButtonModule } from "primeng/button";
import { catchError, forkJoin, of } from 'rxjs';
import { StudentMentorResponse } from '../../models/account/mentor/studentMentorResponse';
import { StudentMentorRequestStatus } from '../../models/enums/studentMentorRequestStatus';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';


@Component({
  selector: 'app-mentor-profile',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, DialogModule, FormsModule, ToastModule, OverlayPanelModule],
  templateUrl: './mentor-profile.component.html',
  styleUrl: './mentor-profile.component.scss'
})
export class MentorProfileComponent implements OnInit{
  @ViewChild('op') overlayPanel!: OverlayPanel;
  mentorId!: string;
  mentor: MentorResponse | undefined;
  allStudentMentors: StudentMentorResponse[] = [];
  countries: countryResponse[] = [];
  portal!:  string;
  safeVideoUrl: SafeResourceUrl | null = null;

  testimonials = [
    {
      text: "Fit's been an overwhelming few days, with the move etc. Secondly, and more importantly, thank you so very much for your email and the song. I truly appreciate the belief you've shown in my abilities throughout this process, and it is partly because of that that I could get whatever admits I got. You've made a world of a difference for me, and I'm so glad we got to work together. Thank you again",
      name: "Divisha",
      subtext: "ISB, Boston University",
      avatarColor: "#F7B801",
      avatarText: "D",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "I'm thrilled to share my admission to the Master of Engineering program at Cornell University for Fall 2026. A huge thank you to the Grad Pilots team for their invaluable support in helping me join Cornell’s Engineering Management program in Ithaca. I couldn't have achieved this milestone without you!",
      name: "Aryan",
      subtext: "ME, Cornell University",
      avatarColor: "#CDD12A",
      avatarText: "A",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "Grad Pilots really transformed my application journey. Their personalized mentoring approach helped me secure a spot at my dream university. The insights into the essays and interviews were absolutely game-changing. I highly recommend them to anyone aiming for top schools!",
      name: "Priya",
      subtext: "MBA, Stanford University",
      avatarColor: "#F7B801",
      avatarText: "P",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "The structure and guidance provided by the team took away all my anxiety. From shortlisting universities to finalizing my SOP, every step was meticulously planned. I couldn't have asked for a better support system during this stressful process.",
      name: "Rahul",
      subtext: "MS CS, Carnegie Mellon",
      avatarColor: "#CDD12A",
      avatarText: "R",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "Mam is a complete goddess! She helps with everything related to the application system, and makes sure you only submit your file when it's at it's best! Without her I wouldn't be in such a great University! Hands down recommend her! I Trust her blindly!",
      name: "Arsh",
      subtext: "Ex Vasant Valley School - McGill University",
      avatarColor: "#F7B801",
      avatarText: "A",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "Scholarship",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "The experience is synonymous with perfection. It's like ma'am and sir put your dreams into perspective for you and help you achieve them. Everything happens with utmost precision. They are the best team, their advice is very precious and they'll treat you like family. They know what they do. I got admitted to all my dream Universities thanks to their combined effort and hard work. Cheers to them!",
      name: "Lavanya",
      subtext: "Ex Modern School - University of Toronto",
      avatarColor: "#CDD12A",
      avatarText: "L",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Scholarship",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "Ma'am was the first person, apart from my family, who instilled in me the confidence that it was possible, and that I could indeed get into top universities in the short time span we had. We worked together for over a month.",
      name: "Aishani",
      subtext: "Babson (Mass) USA",
      avatarColor: "#F7B801",
      avatarText: "A",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "Maam and sir are two of the best people to have by your side if you're thinking of applying to US or Canada. If you're hesitant or confused about your dream of studying abroad then stop overthinking.",
      name: "Sanat",
      subtext: "Ex Modern School, Barakhamba Road - UBC",
      avatarColor: "#CDD12A",
      avatarText: "S",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    }
  ];

  StudentMentorRequestStatus = StudentMentorRequestStatus;
  isAnyMentorPending = false;
  hasApprovedMentor = false;
  isLoading = false;
  visible = false;
  submitted = false;
  purposeToConnect: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private mentorService: MentorService,
    private messageService: MessageService,
    private utilityService: UtilityService,
    private store: Store,
    private sanitizer: DomSanitizer,
  ){}

  

  ngOnInit(): void {
    this.mentorId = this.route.snapshot.paramMap.get('id') || '';
    this.utilityService.getCountries().subscribe({
      next: (res) => this.countries = res.result,
      error: () => this.countries = []
    });
    this.getUser();

    if(this.portal === 'student'){
      forkJoin({
        studentResp: this.mentorService.getStudentMentors(MentorType.Mentor).pipe(
          catchError(err => {
            console.warn('Error fetching student mentors', err);
            return of({ result: [] });
          })
        ),
        mentorResp: this.mentorService.getMentor(this.mentorId).pipe(
          catchError(err => {
            console.warn('Error fetching mentor', err);
            return of(undefined);
          })
        )
      }).subscribe({
        next: ({ studentResp, mentorResp}) => {
          this.allStudentMentors = studentResp.result ?? [];
          this.isAnyMentorPending = this.allStudentMentors.some(item => item.status === StudentMentorRequestStatus.Pending);
          this.hasApprovedMentor = this.allStudentMentors.some(item => item.status === StudentMentorRequestStatus.Approved);
          const studentMentor = this.allStudentMentors.find(item => item.mentorId === this.mentorId);
         
          this.mentor = mentorResp;
          if (this.mentor) {
            this.mentor.status = studentMentor?.status;
            this.mentor.whyToBeMentor = this.mentor.whyToBeMentor?.replace(/&nbsp;/g, ' ');
            this.getSafeVideoUrl();
          }
        }
      })
    }else{
      this.getMentor();
    }
  }

  showDialog(){
    this.visible = true;
  }

  requestMentor() {
    this.submitted = true; // Mark form as submitted
    if (!this.purposeToConnect) { // Check if the field is empty or null
      this.messageService.add({ severity: "error", summary: "Error", detail: "Purpose is required." });
      return; // Stop the function if validation fails
    }

    this.isLoading = true;
    this.mentorService.chooseMentor({
        mentorId: this.mentor!.userId,
        purposeToConnect: this.purposeToConnect!
    }).subscribe({
        next: (response: StudentMentorResponse) => {
            this.isLoading = false;
            this.visible = false; // Close the dialog
            this.purposeToConnect = null; // Clear the field
            this.submitted = false; // Reset submitted state
            if (this.mentor) {
                this.mentor.status = response.status;
                this.isAnyMentorPending = true;
                this.messageService.add({ severity: "success", summary: "Success", detail: "Mentor request sent successfully!" });
            }
        },
        error: (err) => {
            this.isLoading = false;
            this.messageService.add({ severity: "error", summary: "Error", detail: "Mentor request failed!" });
        }
    });
}

 

  getUser(){
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        if(response.role.includes(AuthRoles.Student)){
          this.portal = 'student';
        }else if(response.role.includes(AuthRoles.Mentor)){
          this.portal = 'mentor';
        }
      }
    })
  }

  getMentor(){
    this.mentorService.getMentor(this.mentorId).subscribe({
      next: response => {
        this.mentor = response;
        this.mentor.whyToBeMentor = response.whyToBeMentor?.replace(/&nbsp;/g, ' ');
        this.getSafeVideoUrl();
      },
      error: err => {
        console.error(err);
      }
    })
  }

  getCountryName(arg0: string | null | undefined) {
    if (!arg0) return '';

    return arg0.split(',')
      .map(code => {
        const cleanCode = code.trim();
        return this.countries.find(item => item.countryCode == cleanCode)?.name;
      })
      .filter(name => name)
      .join(', ');
  }


  getSafeVideoUrl(): void | null {
    if (!this.mentor?.profileVideoUrl) return null;

    const url = this.mentor.profileVideoUrl;
  
    // Grab the 11‑char ID no matter which YouTube flavour we get
    //  • full watch URLs         → …watch?v=abcdefghijk
    //  • youtu.be short links    → …youtu.be/abcdefghijk
    //  • Shorts URLs             → …/shorts/abcdefghijk
    const match = url.match(
      /(?:[?&]v=|youtu\.be\/|shorts\/)([\w-]{11})(?=[\?&#]|$)/
    );
  
    const videoId = match?.[1];
    this.safeVideoUrl =  videoId
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`
        )
      : null;
      //Note:
      // autoplay=1: starts playing automatically (allowed only if muted)
      // mute=1: mutes the video to satisfy autoplay policy
      // rel=0: prevents showing related videos at end
      // modestbranding=1: hides the YouTube logo
  }

  
}
